import { render, staticRenderFns } from "./FoodsEmissionFactors.vue?vue&type=template&id=449a1195&scoped=true"
import script from "./FoodsEmissionFactors.vue?vue&type=script&lang=js"
export * from "./FoodsEmissionFactors.vue?vue&type=script&lang=js"
import style0 from "./FoodsEmissionFactors.vue?vue&type=style&index=0&id=449a1195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a1195",
  null
  
)

export default component.exports